module.exports = __webpack_public_path__ + "static/media/mp4.dde8b5da.svg";